<script>
/**
 * 产品卡片（自 vancheen-b2b 的 ProductCard.vue 移植为 Vue 2 版本）
 * - 图片用 el-image（fit=cover + 懒加载）
 * - 规格标签用 el-tag，颜色/内边距仍由 .pc-meta span 决定
 */
import asset from '../nh-asset'

export default {
  name: 'NhProductCard',
  props: {
    product: { type: Object, required: true },
    delay: { type: [Number, String], default: undefined }
  },
  methods: {
    asset
  }
}
</script>

<template>
  <article v-reveal="delay" class="product-card">
    <div class="pc-img">
      <span class="pc-tag" :class="product.cat">{{ product.tag }}</span>
      <el-image :src="asset(product.img)" :alt="product.alt" fit="cover" lazy>
        <template #error>
          <div class="pc-img-fallback">{{ product.name }}</div>
        </template>
      </el-image>
    </div>
    <div class="pc-body">
      <h3 class="pc-name">{{ product.name }}</h3>
      <div class="pc-en">{{ product.en }}</div>
      <p class="pc-desc">{{ product.desc }}</p>
      <div v-if="product.meta && product.meta.length" class="pc-meta">
        <el-tag
          v-for="tag in product.meta"
          :key="tag"
          class="pc-tag-item"
          disable-transitions
        >{{ tag }}</el-tag>
      </div>
    </div>
  </article>
</template>

<style scoped>
.pc-img-fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 12px;
  font-size: 12px;
  color: #9ca3af;
  text-align: center;
}
</style>
